import { type ChannelEntity, getChannelEntityData } from 'models';
import { useInfiniteQuery } from 'query';
import { getChannelEntities } from '../services';
import type { ChannelEntityType } from '../types';
import { getChannelEntitiesQueryKey } from './keys';

type P = {
  channelId: string;
  featured?: boolean;
  pageSize: number;
  subject?: ChannelEntityType;
};

export const useChannelEntitiesQuery = ({ channelId, featured, pageSize, subject }: P) =>
  useInfiniteQuery<ChannelEntity[], number>({
    async queryFn({ pageParam: pageParameter }) {
      const response = await getChannelEntities(channelId, {
        featured,
        limit: pageSize,
        offset: pageParameter,
        subject,
      });

      return response.data.map((entity) => getChannelEntityData(entity));
    },
    initialPageParam: 0,
    getNextPageParam(lastPage, allPages) {
      return lastPage.length < pageSize ? undefined : allPages.length * pageSize;
    },
    queryKey: getChannelEntitiesQueryKey({ channelId, featured, pageSize, subject }),
  });
